<template>
    <div style="height: 100vh;width: 100%;display: none;" :style="{display: 'block'}">
        <el-container style="width: 100%;">
            <el-header class="bs-navbar">
                <div class="container-fluid">
                    <div class="navbar-logo" style="margin-top:15px;">
                        <img src="../../images/logo.png"  style="width:6.2rem;" alt="" >
                    </div>
                    <!-- <div class="collapse-btn" @click="collapseChage">
                        <i v-if="!collapse" class="el-icon-s-fold"></i>
                        <i v-else class="el-icon-s-unfold"></i>
                    </div> -->
                    <!-- Microsoft 365支持中心工单系统 -->
                    <div class="header-title" :style="isMobile?'font-size: 14px;margin-top:13px;':''">{{systemTitle}}</div>
                    <div class="navbar-rbox" >
                        <!-- <div class="nav-weather"><img src="../../images/tianqi.png" alt=""></div> -->
                        <div v-if="!isMobile" class="nav-weather flex-row align-items-center" style="color: white;">你好，{{isSimplePage?simpleName:name}}</div>
                        <div class="user-box" :style="isMobile?'margin-top:50px;':''">
                            <el-dropdown>
                                <img  src="../../images/avatar.png" alt="">
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div @click="onLogout">{{isSimplePage?'去登陆':'登出'}}</div>
                                    </el-dropdown-item>
									<el-dropdown-item v-if="!isSimplePage">
										<router-link to="/reset-password" class="l-link">修改密码</router-link>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </el-header>
            <el-header  v-if="isMobile && !isSimplePage" >
                    <el-menu  :default-active="$route.path" :router="true" class="el-menu-vertical-demo"
                        background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="horizontal"
                        :default-openeds="[]">
                         
                        <el-submenu :index="'empty'">
                            <span slot="title" class="title">功能菜单</span>
                            <el-menu-item :key="'1'" :index="'/'">
                                <span slot="title">首页</span>
                            </el-menu-item>
                            <el-menu-item :key="'4'" :index="'/WorkSheet/Index/2'">
                                <span slot="title">待办工单</span>
                            </el-menu-item>
                            <el-menu-item :key="'15'" :index="'/WorkSheet/Index/5'">
                                <span slot="title">处理中工单</span>
                            </el-menu-item>
                            <el-menu-item :key="'9'" :index="'/WorkSheet/Index/3'">
                                <span slot="title">已完成工单</span>
                            </el-menu-item>
                        </el-submenu>
                        
                    </el-menu>
                    <!-- <el-menu :default-active="$route.path" :router="true" class="el-menu-vertical-demo"
                        background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
                        :default-openeds="['0']">
                        <el-menu-item v-for="(parent,parentIndex) in sidebar.filter(item=>!item.children)"
                                      :key="parent.moduleId"
                                      :index="parent.url||parentIndex.toString()">
                            <span slot="title" class="title">{{parent.moduleName}}</span>
                        </el-menu-item>
                        <el-submenu v-for="(parent,parentIndex) in sidebar.filter(item=>item.children)"
                                    :key="parent.moduleId"
                                    :index="parent.url||parentIndex.toString()">
                            <span slot="title" class="title">{{parent.moduleName}}</span>
                            <el-menu-item v-for="(child,childIndex) in parent.children" :key="child.moduleId"
                                          :index="child.url||(parentIndex+'-'+childIndex)">
                                <span class="subtitle">{{child.moduleName}}</span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu> -->
            </el-header>

            <el-container style="width: 100%;height: calc(100vh - 60px);">
            <!-- {{sidebarDefaultIndex}}--{{$route.path}} -->
                <el-aside  v-if="!isMobile" width="auto" style="height: 100%;background-color:#545c64;padding-bottom: 80px;">
                    <el-menu :default-active="$route.path" :router="true" class="el-menu-vertical-demo"
                        background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :default-openeds="openeds" default-active="/Index"
                        >
                        <!-- :default-openeds="['0']"> -->
                        <el-menu-item v-for="(parent,parentIndex) in sidebar.filter(item=>!item.children)"
                                      :key="parent.moduleId"
                                      :index="parent.url||parentIndex.toString()">
                            <span slot="title" class="title">{{parent.moduleName}}</span>
                        </el-menu-item>
                        <el-submenu v-for="(parent,parentIndex) in sidebar.filter(item=>item.children)"
                                    :key="parent.moduleId"
                                    :index="parent.url||parentIndex.toString()">
                            <span slot="title" class="title">{{parent.moduleName}}</span>
                            <el-menu-item v-for="(child,childIndex) in parent.children" :key="child.moduleId"
                                          :index="child.url||(parentIndex+'-'+childIndex)">
                                <span class="subtitle">{{child.moduleName}}</span>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-main style="width:99.9% !important;height: 101%;background-color: white;overflow-x: hidden;">
                    <div style="flex:1;width:99.9% !important;overflow-x: hidden;">
                        <router-view />
                        <!-- v-if="showRouterView" -->
                        <!-- :key="key" -->
                    </div>
                    
                </el-main>
            </el-container>
            
        </el-container>
        <el-footer>
                <div style="display:flex;justify-content:space-between;margin-top:20px;font-size: small;">
                    <div>
                        <!-- <a href="http://www.langyuntech.com" target="_blank">朗云汇天（北京）科技有限公司</a> -->
                        <span>© 朗云汇天（北京）科技有限公司</span>
                    </div>
                    <div style="padding-right:20px;"><a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备16062507号-1</a></div>
                </div>
                
            </el-footer>
    </div>
</template>

<script>
    import {getToken, removeToken} from "@/utils/auth";
    import {mapGetters} from "vuex";    

    export default {
        name: "Layout",
        data() {
            return {
                slideData: [],
                isRouterAlive: true,
                systemTitle:'',
                // isMobile:false,
                collapse:false,
                isSimplePage:true,
                openeds:['0'],
            }
        },
        computed: {
            ...mapGetters(['name','simpleName','sidebar','sidebarDefaultIndex','isMobile']),
            // key(){
            //     return this.$route.name?this.$roiute.name+new Date():this.$route+new Date()
            // }
        },
        async mounted() {
            // if (localStorage.getItem('loginInfo')){
            //     this.isSimplePage=false
            // }
            if (this.$route.query.token){
                // this.userId = getSimpleToken()                
            }else{
                // this.userId = getToken()
                this.isSimplePage = false
            }

            this.systemTitle = localStorage.getItem('systemTitle');
            this.$store.dispatch("setting/checkDevice");
            console.log('aaa',this.isMobile,this.sidebar)
            // this.isMobile=_isMobile();
            // const token = getToken(), {slideData} = this.$store.state.user;
            // if (!slideData.length) {
            //     try {
            //         const {username, password} = JSON.parse(localStorage.getItem('loginInfo'));
            //         await this.$store.dispatch('user/login', {username, password});
            //         await this.$store.dispatch('user/getUserMenu');
            //     } catch (e) {
            //         await this.$router.replace('/login');
            //         removeToken();
            //     }
            //
            // }
            // if (!token) {
            //     await this.$router.replace('/login');
            //     return;
            // }
        },
        methods: {
            onLogout() {
                localStorage.removeItem('loginInfo');
                removeToken();
                this.$router.replace('/login');
            },
            reload () {
                // this.showRouterView = false
                // this.$nextTick(() => (this.showRouterView = true))
            },
            // 侧边栏折叠
            collapseChage() {
                this.collapse = !this.collapse;
            },
        }
    }
</script>

<style scoped>
    aside {
        padding: 0;
        margin-bottom: 0;
        background: transparent;
        height: 800px;
    }
    .title{
        font-size: 18px;
    }
    .subtitle{
        font-size: 16px;
    }
    .collapse-btn {
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }
</style>